import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";
import React, { useState,useEffect } from "react";
import { useTheme } from "./context/themecontext";

/* -------- DATA -------- */
const ordersByBuyerType = [
  { name: "Builder", value: 145, percentage: 48 },
  { name: "End Home", value: 98, percentage: 32 },
  { name: "Contractor", value: 62, percentage: 20 },
];

const gmvByBuyerType = [
  { type: "Builder", gmv: 320000, orders: 145 },
  { type: "End Home", gmv: 180000, orders: 98 },
  { type: "Contractor", gmv: 150000, orders: 62 },
];

const COLORS = ["#2563eb", "#10b981", "#f59e0b"];

export default function OrderAnalyticsSection() {
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;  

  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const [period,setPeriod] = useState('week');
  const [gmvByBuyerType,setgmvByBuyerType] = useState();
  const [ordersByBuyerType,setordersByBuyerType] = useState();

      useEffect(() => {
      fetchOrderAnalyticsData(period);
    }, [period]);
  
  const fetchOrderAnalyticsData = async () => {
    try {
      const manufacturerId = sessionStorage.getItem("userId");
      console.log("Manufacturer ID:", manufacturerId);
  
      // ✅ Correct URL (no /brickbucket here)
      const apiUrl = `${fetchUrl}manufacturer/get-manufacturer-order-analytics-data?manufacturerId=${manufacturerId}&period=${period}`;
      console.log("Fetching URL:", apiUrl);
  
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      const data = await response.json();
      console.log("Order Analytics Data:", data);
  
      if (response.ok && data) {
        console.log(data.data)
        setgmvByBuyerType(data?.data?.gmvByBuyerType);
        setordersByBuyerType(data?.data?.ordersByBuyerType)
      } else {
        console.error(
          "Failed to fetch Order Analytics data:",
          data.message
        );
      }
    } catch (error) {
      console.error("Error in fetchOrderAnalyticsData:", error);
    }
  };

  const handlePeriodChange = (e) => {
  setPeriod(e.target.value);
};

console.log(gmvByBuyerType);
console.log(ordersByBuyerType);

  return (
    <div className="space-y-4 md:space-y-8">

      {/* HEADER */}
      <div className="flex items-center justify-between">
        <h2 className={`text-lg md:text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Order Analytics</h2>
            <select
              value={period}
              onChange={handlePeriodChange}
              className={`border rounded-md px-1 py-1 sm:px-3 sm:py-2 text-xs sm:text-sm whitespace-nowrap flex-shrink-0 ${
                isDarkMode
                  ? 'bg-gray-700 text-gray-200 border-gray-600'
                  : 'bg-white text-gray-900 border-gray-200'
              }`}
            >
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="quarter">This Quarter</option>
              <option value="year">This Year</option>
            </select>
      </div>

      {/* SUMMARY CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        {ordersByBuyerType?.map((item, index) => (
          <div
            key={index}
            className={`${isDarkMode ? 'bg-gray-800 border border-gray-700 text-gray-200' : 'bg-white border rounded-xl p-4 shadow-sm'} rounded-xl p-4`}
          >
            <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-500'} text-sm`}>{item?.name} Orders</p>
            <p className={`text-lg md:text-2xl font-bold mt-1 ${isDarkMode ? 'text-white' : ''}`}>{item?.value}</p>
            <p className="text-xs text-gray-600 mt-1">
              {item?.percentage}% of total orders
            </p>
          </div>
        ))}
      </div>

      {/* CHARTS */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-6">

        {/* PIE CHART */}
        <div className={`${isDarkMode ? 'bg-gray-800 border border-gray-700 text-gray-200' : 'bg-white border rounded-xl p-4'} rounded-xl p-4`}>
          <h3 className={`font-semibold mb-4 ${isDarkMode ? 'text-white' : ''}`}>
            Orders Distribution by Buyer Type
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={ordersByBuyerType}
                dataKey="value"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={({ name, percentage }) =>
                  `${name}: ${percentage}%`
                }
              >
                {ordersByBuyerType?.map((_, index) => (
                  <Cell
                    key={index}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* BAR CHART */}
{/*         <div className="bg-white border rounded-xl p-4">
          <h3 className="font-semibold mb-4">
            GMV by Buyer Type
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={gmvByBuyerType}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="type" />
              <YAxis />
              <Tooltip
                formatter={(value) =>
                  `₹${value.toLocaleString()}`
                }
              />
              <Legend />
              <Bar dataKey="gmv" fill="#2563eb" name="GMV" />
            </BarChart>
          </ResponsiveContainer>
        </div> */}
      </div>

      {/* TABLE */}
        <div className={`${isDarkMode ? 'bg-gray-800 border border-gray-700 text-gray-200' : 'bg-white border rounded-xl p-4'} rounded-xl p-4`}>
        <h3 className={`font-semibold mb-4 ${isDarkMode ? 'text-white' : ''}`}>
          Buyer Type Summary
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className={`border-b text-left ${isDarkMode ? 'border-gray-700' : ''}`}>
                <th className={`py-3 px-4 ${isDarkMode ? 'text-gray-200' : ''}`}>Buyer Type</th>
                <th className={`py-3 px-4 ${isDarkMode ? 'text-gray-200' : ''}`}>Total Orders</th>
                <th className={`py-3 px-4 ${isDarkMode ? 'text-gray-200' : ''}`}>Total GMV</th>
                <th className={`py-3 px-4 ${isDarkMode ? 'text-gray-200' : ''}`}>Avg Order Value</th>
                <th className={`py-3 px-4 ${isDarkMode ? 'text-gray-200' : ''}`}>% of Total</th>
              </tr>
            </thead>
            <tbody>
              {gmvByBuyerType?.map((item, index) => (
                <tr
                  key={index}
                  className={`border-b ${isDarkMode ? 'border-gray-700' : ''} ${isDarkMode ? '' : 'hover:bg-gray-50'}`}
                >
                  <td className="py-3 px-4 font-medium">
                    {item?.type}
                  </td>
                  <td className="py-3 px-4">
                    {item?.orders}
                  </td>
                  <td className="py-3 px-4">
                    ₹{item?.gmv?.toLocaleString()}
                  </td>
                  <td className="py-3 px-4">
                    ₹
                    {Math.round(
                      item?.gmv / item?.orders
                    )?.toLocaleString()}
                  </td>
                  <td className="py-3 px-4">
                    {ordersByBuyerType[index]?.percentage}%
                  </td>
                </tr>
              ))}

              {/* TOTAL ROW */}
              <tr className={`${isDarkMode ? 'font-bold bg-gray-700' : 'font-bold bg-gray-50'}`}>
                <td className="py-3 px-4">Total</td>
                <td className="py-3 px-4">
                  {gmvByBuyerType?.reduce(
                    (sum, i) => sum + i.orders,
                    0
                  )}
                </td>
                <td className="py-3 px-4">
                  ₹
                  {gmvByBuyerType
                    ?.reduce((sum, i) => sum + i.gmv, 0)
                    ?.toLocaleString()}
                </td>
                <td className="py-3 px-4">-</td>
                <td className="py-3 px-4">100%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
